/* eslint-disable no-nested-ternary */
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  label: {
    padding: 'var(--ui-spacer-xxs) var(--ui-spacer-xs)',
    borderRadius: 'var(--ui-radius-m)',
    display: 'flex',

  },
  labelText: {
    fontSize: '1.1rem',
    lineHeight: '1em',
  },
  labelBooked: {
    backgroundColor: 'var(--ui-class-state-label-booked-background-color)',
  },
  labelTextBooked: {
    color: 'var(--ui-class-state-label-booked-color)',
  },
  labelWaitlist: {
    backgroundColor: 'var(--ui-class-state-label-waitlist-background-color)',
  },
  labelTextWaitlist: {
    color: 'var(--ui-class-state-label-waitlist-color)',
  },
  labelFull: {
    backgroundColor: 'var(--ui-class-state-label-full-background-color)',
  },
  labelTextFull: {
    color: 'var(--ui-class-state-label-full-color)',
  },
}))

export default useStyles
